export default __webpack_public_path__ + "formulario4.jpg";